import { Component, Fragment } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import AxlModal from 'AxlMUIComponent/AxlModal';
import DriverProfileInformation from '../DriverProfileInformation';
import DriverProfileRoutingTabs from '../DriverProfileRoutingTabs';
import styles, * as E from '../HistoryList/styles';

const objectTypes = {
  DR: 'Driver',
  AS: 'Assignment',
  SH: 'Shipment',
  ST: 'Stop',
  US: 'User',
  CL: 'Client',
};

class EventObject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      driverData: {},
      showDriverProfile: false,
    };
    this.onShowDriverProfile = this.onShowDriverProfile.bind(this);
  }

  onShowDriverProfile = (driver) => {
    const that = this;

    if (driver) {
      this.props.driverStore.get(driver, (res) => {
        if (res.status === 200) {
          that.setState({ driverData: res.data, showDriverProfile: true });
        }
      });
    }
  };
  onHideDriverProfile = () => {
    this.setState({ showDriverProfile: false });
  };

  render() {
    const { obj } = this.props;
    if (!obj) return <span></span>;
    const { uid } = obj;
    const type = uid ? objectTypes[uid.split('\_')[0]] : '';
    const objectID = uid.split('\_')[1];
    const { showDriverProfile, driverData } = this.state;
    const name = obj.attributes?.name ? obj.attributes.name : '';
    if (type === 'Driver')
      return (
        <Fragment>
          <E.DriverLink onClick={() => this.onShowDriverProfile(objectID)}>
            {type} <strong style={styles.strong}>{name}</strong> [{objectID}]
          </E.DriverLink>
          {showDriverProfile && driverData && (
            <AxlModal style={styles.modalDriverProfileContainer} onClose={this.onHideDriverProfile}>
              <DriverProfileInformation driver={driverData} />
              <DriverProfileRoutingTabs driver={driverData} onSave={this.onHideDriverProfile} history={this.props.history} />
            </AxlModal>
          )}
        </Fragment>
      );
    return (
      <span>
        {type} <strong style={styles.strong}>{name}</strong> [{objectID}]
      </span>
    );
  }
}

export default compose(withRouter, inject('store'), observer)(EventObject);
